var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { constructActions } from '../actions';
import { constructParameters } from '../parameters';
import { DefinitionType } from '../types';
export const constructFromActionDefinition = (actionDef, resourceRegistry, symbolTable, errors) => __awaiter(void 0, void 0, void 0, function* () {
    const definition = actionDef.action;
    const parameters = constructParameters(definition.params);
    const actions = yield constructActions(definition.spec, resourceRegistry, symbolTable);
    return {
        type: DefinitionType.Action,
        name: definition.name,
        description: definition.description,
        parameters,
        actions: actions !== null && actions !== void 0 ? actions : [],
        isDerived: false,
        errors,
    };
});
//# sourceMappingURL=action.js.map